<template>
  <div class="cp-mobility-rent">
    <div class="teq-container">
      <h2>louer un véhicule Renault</h2>
      <div class="flex-container">
        <div class="item">
          <a href="/vehicules/citadines">
            <img
              class="illust"
              src="../../../images/citadine.webp"
              alt=""
            >
            <h3>citadines</h3>
          </a>
        </div>
        <div class="item">
          <a href="/vehicules/utilitaires">
            <img
              class="illust"
              src="../../../images/utilitaire.webp"
              alt=""
            >
            <h3>utilitaires</h3>
          </a>
        </div>
        <div class="item">
          <a href="/vehicules/familiales">
            <img
              class="illust"
              src="../../../images/familiale.webp"
              alt=""
            >
            <h3>familiales</h3>
          </a>
        </div>
      </div>
      <div class="button-container">
        <rent-button @buttonclicked="redirectToVehicles">
          tous les véhicules
        </rent-button>
        <rent-button
          class="-transparent"
          :href="'/agences'"
          @buttonclicked="redirectToAgences"
        >
          nos agences
        </rent-button>
      </div>
    </div>
  </div>
</template>

<script>
import RentButton from '../shared/RentButton'

export default {
  name: 'MobilityRent',

  props: {
    isMobility: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RentButton,
  },
  methods: {
    redirectToVehicles() {
      window.location = '/vehicules'
    },
    redirectToAgences() {
      window.location = '/agences'
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.cp-mobility-rent {
  background: #f5f5f5;
  box-sizing: border-box;
  padding: 2rem 0;

  @include teq-breakpoint($large) {
    padding: 4.5rem 0 6rem;
  }
}

.teq-container {
  align-content: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.flex-container {
  margin-bottom: 4rem;

  @include teq-breakpoint($large) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.item {
  margin-bottom: 2rem;
  overflow: hidden;
  position: relative;

  @include teq-breakpoint($large) {
    margin-bottom: 0;
    transition: 0.8s;
    width: calc(33% - 1.3rem);
  }

  &::before {
    content: "";
    display: block;
    padding-top: (21 / 20) * 100%;
    width: 100%;
  }

  &::after {
    background: #000;
    content: '';
    height: 100%;
    left: 0;
    object-fit: cover;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 5;
  }

  &:hover {
    cursor: pointer;

    img {
      @include teq-breakpoint($large) {
        transform: scale(1.03);
      }
    }
  }
}

img {
  transition: 0.8s;
}

.illust {
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
}

h2 {
  font-size: 4.8rem;
  line-height: 100%;

  @include teq-breakpoint($large) {
    font-size: 7.2rem;
  }
}

h3 {
  color: #fff;
  font-size: 2.8rem;
  left: 50%;
  line-height: 3rem;
  position: absolute;
  text-align: center;
  top: 44%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.button-container {
  @include teq-breakpoint($large) {
    margin: 0 auto;

    button {
      margin: 0;
      width: auto;
    }
  }

  .rent-button {
    @include teq-breakpoint($large) {
      display: inline-block;
    }
  }
}

</style>
